var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"w-full wrapper-chart",attrs:{"id":"chart"}},[_c('VueApexCharts',{attrs:{"type":"area","height":"350","options":_vm.chartOptions,"series":_vm.seriesStatusChart}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }